import Component from "../core/Component";

import scrollTo from "../services/Viewport/scrollTo";


export default class ScrollToTarget extends Component {

	constructor(element) {
		super(element);
	}

	prepare() {
		this.element.addEventListener("click", ::this.handleClick);
	}

	handleClick(event) {
		event.preventDefault();
		const elTarget = this.element.getAttribute("data-target");
		const elOffset = this.element.getAttribute("data-offset");
		const elm = document.getElementById(elTarget);
		const bodyRect = document.body.getBoundingClientRect(),
			elementRect = elm.getBoundingClientRect(),
			offset = elementRect.top - bodyRect.top - elOffset;
		scrollTo(offset);
	}
}
